// services/userApi.js or wherever userApi is defined
import { apiSlice } from "services/apiSlice";

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: () => "user",
      providesTags: ["Users"],
    }),
    getUserById: builder.query({
      query: (id) => `user/${id}`,
      providesTags: ["Users"],
    }),
    getUsersBySupplierAndRole: builder.query({
      query: (supplierId) => `user/supplier/${supplierId}`,
      providesTags: ["Users"],
    }),
    getValidateursByCompany: builder.query({
      query: (companyId) => `user/validateurs/${companyId}`,
      providesTags: ["Users"],
    }),
    createUser: builder.mutation({
      query: (formData) => ({
        url: "user",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Users"],
    }),
    getUsersByCompanyId: builder.query({
      query: (companyId) => `user/companyId/${companyId}`,
      providesTags: ["Users"],
    }),
    updatePersonalInfo: builder.mutation({
      query: ({ userId, data }) => ({
        url: `user/update-personal/${userId}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Users"],
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `user/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["supplierUsers"],
    }),
    updateUser: builder.mutation({
      query: ({ userId, data }) => {
        // si data est un FormData (avec fichier), on l’envoie directement
        const isFormData = data instanceof FormData;

        return {
          url: `user/${userId}`,
          method: "PATCH",
          body: data,
          // RTK Query ajoute automatiquement les headers sauf si c'est un FormData
          headers: isFormData ? {} : { "Content-Type": "application/json" },
        };
      },
      invalidatesTags: ["Users"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUsersQuery,
  useGetUserByIdQuery,
  useGetValidateursByCompanyQuery,
  useUpdatePersonalInfoMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useGetUsersByCompanyIdQuery,
  useCreateUserMutation,
  useGetUsersBySupplierAndRoleQuery,
} = userApi;
